import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {QBUserMapping} from "@app/shared/classes/quickbooks/qbuser-mapping";
import {
  CommonTransformationService,
  DateService,
  FileService,
  Format,
  HrService,
  PrimeNgConfig,
  PrimeNgSupportService,
  TableColumn,
  TradingPartnerService, TradingPartnerType,
  UserParam,
  UserSummary,
  Validation
} from "@app/shared";
import {ConfirmationService, SelectItem} from "primeng/api";
import {QuickBooksImportDataService} from "@app/finance/time/quickbooks/quick-books-import-data.service";
import {plainToClass} from "class-transformer";
import {InvoiceImportVendorMapping} from "@app/shared/classes/dataimport/invoice-import-item";
import {ImportDataService} from "@app/shared/import/data-import/import-data.service";
import {GrowlService} from "@app/core";

@Component({
  selector: 'app-invoice-vendor-mappings',
  templateUrl: './invoice-vendor-mappings.component.html',
  styleUrls: ['./invoice-vendor-mappings.component.css']
})
export class InvoiceVendorMappingsComponent implements OnInit,AfterViewInit {

  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  vendorMappings: InvoiceImportVendorMapping[]
  tableColumns: TableColumn[] = [];
  vendorDropDown: SelectItem<number>[] = [];

  @ViewChild('vendorTemplate') vendorTemplate: TemplateRef<any>;

  constructor(private importService: ImportDataService,
              private tpService: TradingPartnerService,
              private primeNgService: PrimeNgSupportService,  private fileService: FileService, private dateService: DateService,
              private transformationService: CommonTransformationService,
              private confirmationService: ConfirmationService,
              private growl: GrowlService) { }

  ngOnInit(): void {

    this.buildDropDowns();
    this.getVendorMappings();

  }

  ngAfterViewInit(): void {
    this.buildTableColumns();
  }


  importVendorMappings() {
    this.importService.importVendorMappings().subscribe(res => {
      this.getVendorMappings();
    })
  }

  getVendorMappings() {
    this.importService.getVendorMappings().subscribe(res => {
      this.vendorMappings = plainToClass(InvoiceImportVendorMapping, res);
    })
  }

  onClickSaveMappings() {
    let validMappings: InvoiceImportVendorMapping [] = [];
    // validMappings = this.vendorMappings.filter(map => map?.userId);
    this.importService.saveVendorMappings(this.vendorMappings).subscribe(res => {
      // Since front end sent only valid mappings, get the values again so that all users are displayed.
      this.getVendorMappings();
    })
  }

  private buildDropDowns(): void {
    this.tpService.getPartnersAsDropdown(TradingPartnerType.Vendor).subscribe(res => {
      this.vendorDropDown = res;
    });
  }

  private buildTableColumns(): void {
    this.tableColumns = [
      {field: 'displayLabel', header: 'External System Vendor'},
      {field: 'vendorId', header: 'Onelynk Vendor', template: this.vendorTemplate}
    ];
  }

}
